import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const toggleInputFn = /* @__PURE__ */ createRecipe('toggle-input', {}, [])

const toggleInputVariantMap = {}

const toggleInputVariantKeys = Object.keys(toggleInputVariantMap)

export const toggleInput = /* @__PURE__ */ Object.assign(memo(toggleInputFn.recipeFn), {
  __recipe__: true,
  __name__: 'toggleInput',
  __getCompoundVariantCss__: toggleInputFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: toggleInputVariantKeys,
  variantMap: toggleInputVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, toggleInputVariantKeys)
  },
  getVariantProps: toggleInputFn.getVariantProps,
})